import UserHero from "./UserHero";

export default UserHero;
